import BasicCard from '../../../../components/basicCard/BasicCard';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

type NewsLetterProps = {
  name: string;
  summary: string;
  id: number;
  t: (key: any) => string;
};

const NewsLetter = ({ name, summary, id, t }: NewsLetterProps) => {
  const navigate = useNavigate();

  const navigateToViewNewsLetter = (id: number) => {
    navigate(`home/newsletter/view/${id}`,{ state: 'home' });
  };

  return (
    <div className="report w-full">
      <BasicCard radius="lg">
        <div className="flex items-center justify-between px-5 py-4 gap-2 md:gap-4">
          <div className="content flex-1 min-w-0 space-y-2">
            <h3 className="report-name text-xl font-bold truncate" title={name}>{name}</h3>
            <p className="report-info text-md md:text-lg text-[#525252] truncate w-40 md:w-auto" title={summary}>{summary}</p>
          </div>
          <div className="buttons flex place-items-center">
            <button
              className="flex aspect-auto items-center justify-center gap-2 rounded-3xl bg-gradient-to-t from-secondary to-primary px-4 py-2 !text-sm text-white"
              onClick={() => {
                navigateToViewNewsLetter(id);
              }}
            >
              {t('view')} <FaExternalLinkAlt />
            </button>
          </div>
        </div>
      </BasicCard>
    </div>
  );
};

export default NewsLetter;
